import { api } from '../configs/axiosConfigs';

export type PropertyPosition = {
  position: number | null;
  total: number;
};

// Zero-based index of a property in the list as currently filtered/sorted, or null if filtered out
export const getPropertyPosition = async(listSortId: string, ransackObj: any, propertyId: string): Promise<PropertyPosition> => {
  const response = await api.post(
    `list-sorts/${listSortId}/property_position?property_id=${encodeURIComponent(propertyId)}`,
    ransackObj
  );
  return response.data;
};
